var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"height":"100%","overflow-y":"auto"}},[(_vm.paperData)?_c('QuesParser',{attrs:{"paper-data":_vm.paperData,"form-data":_vm.formData,"paper-log":_vm.paperLog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }